import { generateSpectrum } from 'spectrum-generator';
export function peaksToXY(peaks, options = {}) {
    const { from, to, nbPoints = 1024, shape } = options;
    return generateSpectrum(peaks, {
        generator: {
            from,
            to,
            nbPoints,
            shape,
        },
    });
}
//# sourceMappingURL=peaksToXY.js.map